<script setup lang="ts">
// The five readings a visit can carry, named on the card that draws them.
//
// The key used to be one row in the Analysis pane, between the weekly stack and
// the map. Enlarging a card teleports that card's own section into the overlay
// host, so anything rendered beside the cards stays behind: an enlarged stack or
// Site list showed five colours and named none of them. Each card carrying its
// own key is what makes it self-contained — the same markup reads in the rail
// and at full size, with no second copy to drift from this one.
//
// The row is deliberately a group rather than a bare div: `aria-label` only
// reaches a screen reader on an element with a role to hang it on.
import { WASTE_OUTCOMES } from "./wasteTheme";
</script>

<template>
	<div class="outcome-key" role="group" aria-label="Visit outcomes">
		<span v-for="outcome in WASTE_OUTCOMES" :key="outcome.key" class="key">
			<span class="swatch" :style="{ background: outcome.color }" />
			{{ outcome.label }}
		</span>
	</div>
</template>

<style scoped>
/* Sized as a caption, not as prose: it sits under a chart and must not compete
   with the axis labels or the panel title. Wrapping rather than clipping keeps
   the rail's width — the five labels are far longer than one line of it. */
.outcome-key {
	display: flex;
	flex-wrap: wrap;
	gap: 4px 10px;
	min-width: 0;
	margin: 8px 0 0;
	font-size: 0.7rem;
	line-height: 1.35;
	color: #6c757d;
}

.key {
	display: flex;
	align-items: center;
	gap: 5px;
	min-width: 0;
}

/* A square chip, not a bar: the weekly stack's swatches are bars because they
   key a fill, and this one keys a colour that appears in several shapes. */
.swatch {
	flex: 0 0 auto;
	width: 10px;
	height: 10px;
	border-radius: 2px;
}
</style>
